module.exports = __webpack_public_path__ + "static/media/whiskey-barrel.0afa9185.svg";